import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { HttpsService } from "./bancreachwebsite/services/http/http.service";
import { environment } from "src/environments/environment";
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import { initializeApp } from "firebase/app";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "bancreach";
  user: any;
  serviceWorkerAttempt = 0;
  displayToken: any;
  landingUrl: string = environment.landingUrl;
  message: any;
  constructor(private router: Router, private http: HttpsService) {
  }

  ngOnInit() {
    localStorage.setItem("isStart", "false");
    this.user = JSON.parse(localStorage.getItem("bancreach_web_user"));
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  onActivate(event) {
    window.scrollTo(0, 0);
  }
}
